import { StateCreator } from "zustand";


export type TMenuHeaderState = {
  itemHeaderCurrentSection?: string;
  setItemHeaderCurrentSection: (id: string) => void
  clearMenuHeader: () => void
};

export const createMenuHeaderState: StateCreator<
  TMenuHeaderState,
  [],
  [],
  TMenuHeaderState
> = (set) => ({
  setItemHeaderCurrentSection: (id) => {
    set(() => ({
      itemHeaderCurrentSection: id,
    }))
  },
  clearMenuHeader: () => {
    set(() => ({
      itemHeaderCurrentSection: undefined,
    }))
  },
})
